import { render, staticRenderFns } from "./ask-push.vue?vue&type=template&id=55b8706e"
import script from "./ask-push.vue?vue&type=script&lang=js"
export * from "./ask-push.vue?vue&type=script&lang=js"
import style0 from "./ask-push.vue?vue&type=style&index=0&id=55b8706e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55b8706e')) {
      api.createRecord('55b8706e', component.options)
    } else {
      api.reload('55b8706e', component.options)
    }
    module.hot.accept("./ask-push.vue?vue&type=template&id=55b8706e", function () {
      api.rerender('55b8706e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade/ask-push.vue"
export default component.exports